import { useEffect, useState } from "react";
import useQueryParams from "../../hooks/useQueryParams";
import Label from "../../components/form/Label";
import ButtonIconOnly from "../../components/ui/button/ButtonIconOnly";

const TableFilter = ({ resetFilters }) => {
  const { updateQueryParam, queryParams } = useQueryParams();

  // Initialize state from URL params first, then fallback to sessionStorage
  const [searchValue, setSearchValue] = useState(queryParams.get("search") || sessionStorage.getItem("customer_search") || "");
  const [ageValue, setAgeValue] = useState(queryParams.get("age") || sessionStorage.getItem("customer_age") || "");
  const [genderValue, setGenderValue] = useState(queryParams.get("gender") || sessionStorage.getItem("customer_gender") || "");

  // Sync internal state with URL changes (e.g. back button, pagination)
  useEffect(() => {
    const search = queryParams.get("search");
    const age = queryParams.get("age");
    const gender = queryParams.get("gender");

    // Only update if the URL actually has these params (don't overwrite with null if they're missing from URL but present in storage)
    if (search !== null) setSearchValue(search);
    if (age !== null) setAgeValue(age);
    if (gender !== null) setGenderValue(gender);
  }, [queryParams.toString()]);

  const handleSearchClick = () => {
    updateQueryParam("page", 0);
    updateQueryParam("search", searchValue);
    updateQueryParam("age", ageValue);
    updateQueryParam("gender", genderValue);
  };


  return (
    <div className="flex flex-col md:flex-row md:items-end gap-3 flex-wrap">
      <div className="flex flex-col w-full md:w-64">
        <Label variant="filter" title="Name" />
        <input
          className="search-button-input-hover"
          type="text"
          value={searchValue}
          placeholder="Eg: John"
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>

      <div className="flex flex-col w-full md:w-32">
        <Label variant="filter" title="Age" />
        <input
          className="search-button-input-hover"
          type="number"
          value={ageValue}
          placeholder="Eg: 25"
          onChange={(e) => setAgeValue(e.target.value)}
        />
      </div>

      <div className="flex flex-col w-full md:w-40">
        <Label variant="filter" title="Gender" />
        <select
          className="search-button-input-hover pr-8"
          value={genderValue}
          onChange={(e) => setGenderValue(e.target.value)}
        >
          <option value="">Select Gender</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
        </select>
      </div>

      <div className="flex flex-col md:ml-auto">
        <Label variant="filter" title="&nbsp;" className="hidden md:block" />
        <div className="flex items-center gap-6">
          <button
            onClick={handleSearchClick}
            className="search-button"
          >
            Search
          </button>
          <ButtonIconOnly
            title="Reset"
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 transition flex items-center justify-center"
            icon={
              <svg className="w-5 h-5" viewBox="0 0 512 512" fill="currentColor">
                <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z" />
              </svg>
            }
            onClick={() => {
              setSearchValue("");
              setAgeValue("");
              setGenderValue("");
              sessionStorage.removeItem("customer_search");
              sessionStorage.removeItem("customer_age");
              sessionStorage.removeItem("customer_gender");
              resetFilters();
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default TableFilter;
